import React from 'react';
import { styled } from '@xstyled/styled-components';
import { TitleFieldProps } from '../types';
import { FieldWrapper, Label } from '../sharedComponents';

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  font-family: Raleway;
  font-size: 14px;
  background: #f8f9fa;
  &:focus {
    outline: none;
    border-color: #9738ff;
    background: white;
  }
  &::placeholder {
    color: #999;
  }
  @media (max-height: 900px) {
    padding: 10px 14px;
    font-size: 13px;
  }
  @media (max-height: 780px) {
    padding: 8px 12px;
    font-size: 12.5px;
  }
`;

export const TitleField: React.FC<TitleFieldProps> = ({
  value,
  onChange,
  maxLength = 120,
  placeholder = 'Enter title',
  disabled = false,
  required = false
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  return (
    <FieldWrapper>
      <Label htmlFor="card-title">Card Title</Label>
      <Input
        id="card-title"
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
        aria-label="Card Title"
      />
    </FieldWrapper>
  );
};
